import { Mesh, Geometry, MeshPhongMaterial } from 'three';

export class PartsMesh {
    private parts: Mesh<Geometry, MeshPhongMaterial>;

    private origin: MeshPhongMaterial | null;

    public constructor(parts: Mesh<Geometry, MeshPhongMaterial>, enableRestore: boolean) {
        this.parts = parts;
        this.origin = null;
        if (enableRestore) {
            this.origin = this.parts.material.clone();
        }
    }

    public reset(): void {
        if (this.origin === null) {
            return;
        }

        if (
            this.parts.material.map?.uuid === this.origin?.map?.uuid
            && this.parts.material.alphaMap?.uuid === this.origin?.alphaMap?.uuid
        ) {
            console.log('[PartsMesh] skip reset, because same mat', this.parts.name);
            return;
        }

        console.log('[PartsMesh] reset material', this.parts.name);
        this.parts.material.dispose();
        this.parts.material = this.origin.clone();
        this.parts.material.needsUpdate = true;
    }

    get mat(): MeshPhongMaterial {
        return this.parts.material;
    }

    get target(): Mesh<Geometry, MeshPhongMaterial> {
        return this.parts;
    }

    public show(): void {
        this.parts.visible = true;
    }

    public hide(): void {
        this.parts.visible = false;
    }
}
